module.exports = __webpack_public_path__ + "img/android_4.b3bc92ef.jpg";